import { $EnterTraffic, $CurrentTraffic } from '@lemon8/web-app-shared/atom';
import { ExtractAtomValue } from 'jotai';
import { EPageType } from 'shared/models';
import { defineProxyAtom } from '@lemon8/web-app-shared/util';
import { TCurrentTraffic } from 'shared/models/#common/current-traffic';

interface ISEOEnterTraffic extends ExtractAtomValue<typeof $EnterTraffic> {
  pageType: EPageType;
}

export const $SEOEnterTraffic = defineProxyAtom<ISEOEnterTraffic, ExtractAtomValue<typeof $EnterTraffic>>(
  $EnterTraffic,
);
$SEOEnterTraffic.debugLabel = '$SEOEnterTraffic';

export const $SEOCurrentTraffic = defineProxyAtom<TCurrentTraffic, ExtractAtomValue<typeof $CurrentTraffic>>(
  $CurrentTraffic,
);
$SEOCurrentTraffic.debugLabel = '$SEOCurrentTraffic';
